module.exports = __webpack_public_path__ + "img/signature.4cbb44f7.svg";